var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrevArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.544 11.007l6.928-6.867A1.73 1.73 0 0 0 14 2.861c0-.504-.176-.93-.528-1.278L12.403.523A1.763 1.763 0 0 0 11.113 0c-.508 0-.938.174-1.29.523L.528 9.72A1.731 1.731 0 0 0 0 11c0 .504.176.93.528 1.279l9.295 9.198c.352.349.782.523 1.29.523.509 0 .939-.174 1.29-.523l1.07-1.06c.351-.348.527-.772.527-1.271 0-.5-.176-.928-.528-1.286l-6.928-6.853z",
  fill: "#FFF",
  fillRule: "nonzero"
})));
export default SvgPrevArrow;